"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolveServiceDeactivations = resolveServiceDeactivations;
const resolveBindingsDeactivations_1 = require("./resolveBindingsDeactivations");
function resolveServiceDeactivations(params, serviceIdentifier) {
    const bindings = params.getBindings(serviceIdentifier);
    return (0, resolveBindingsDeactivations_1.resolveBindingsDeactivations)(params, bindings);
}
//# sourceMappingURL=resolveServiceDeactivations.js.map